import axios from 'axios'

// Every backend route is scope-protected. A 403 means the session is valid but the token
// does not carry the scope the route requires — it is an authorization verdict, not a
// transient failure, and it is never retried (see `retryOnlyTransient` in
// src/lib/react-query/client.ts).
//
// This is distinct from a 401, which the interceptor may resolve by refreshing the token.
export const isForbiddenError = (error: unknown): boolean =>
  axios.isAxiosError(error) && error.response?.status === 403
